<template>
  <el-row>
    <el-col>
      <h2>Change PEA Owner</h2>
      <el-row>
        <el-col>
          PEA ID: <el-input v-model="peaId" :disabled="disabled"></el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          UserName of new Owner<el-input v-model="userName" :disabled="disabled"></el-input>
        </el-col>
      </el-row>
      <br />
      <el-row>
        <el-col>
          <el-alert v-if="alertTitle !== ''"
            :title="alertTitle"
            :type="alertType"
            :description="callInfo"
            :closable="false"
            show-icon>
          </el-alert>
          <button class="btn btn-primary" @click="change()">Change!</button>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>
<script>
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  name: 'changePEAOwner',
  data () {
    return {
      userName: '',
      peaId: '',
      isLoading: false,
      alertType: '',
      alertTitle: '',
      callInfo: '',
      disabled: true
    }
  },
  methods: {
    startUp () {
      if (this.$store.getters.isAdmin || this.$store.getters.isServiceDesk) {
        this.disabled = false
      } else {
        this.disabled = true
      }
    },
    change () {
      var call = '/changePEAOwner/' + this.peaId + '?username=' + this.userName
      // this promised handled by peaMain
      this.$axios.post(call).then(response => {
        this.isLoading = false
        helperMethods.showNotification(this, 'PEA Owner Changed!', 'PEA Change', 'success', 10000)
      })
        .catch(reject => {
          this.isLoading = false
          helperMethods.showNotification(this, 'Error changing PEA', reject.body, 'error', 30000)
        })
    }
  },
  mounted () {
    this.startUp()
  },
  watch: {
    // watch for route change - going from peaId/4 to peaId/0
    '$route': 'startUp'
  }
}
</script>
